module.exports = new __parcel__URL__("Priestskill_50.ae20b08b.png").toString();